let PhoneFormat = () => {
  return (input) => {
  	let formatted = input + '';
  	formatted = formatted.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  	return formatted;
  }
};

PhoneFormat.$inject = [];

export default PhoneFormat;



// WEBPACK FOOTER //
// ./client/app/common/filters/phone-format.js